import { useTimeGate } from '@exam-center/server-time';
import { Button, type ButtonProps, HistoryOutlinedIcon } from '@shared/components';
import { useMemo } from 'react';

import type { ExamEventCourse, ExamEventSession } from '../../types';
import { getSessionLatestCourseCompletionTime } from '../../utils';

export interface TimeExtensionHistoryButtonProps extends Pick<ButtonProps, 'onClick' | 'loading'> {
  hidden: boolean;
  currentSession: ExamEventSession;
  participatedCourses: ExamEventCourse[];
  postponeDuration: number;
}

export default function TimeExtensionHistoryButton(
  props: Readonly<TimeExtensionHistoryButtonProps>,
) {
  const { loading, onClick, hidden, currentSession, participatedCourses, postponeDuration } = props;

  const latestSessionCompletionDate = useMemo(
    () =>
      currentSession
        ? getSessionLatestCourseCompletionTime(
            participatedCourses,
            currentSession,
            postponeDuration,
          )
        : new Date(0),
    [participatedCourses, currentSession, postponeDuration],
  );

  const isPastLatestSessionCompletion = useTimeGate(latestSessionCompletionDate);

  const shouldHide = hidden || loading || !isPastLatestSessionCompletion;

  if (shouldHide) return null;

  return (
    <Button
      onClick={onClick}
      sx={{ height: 'fit-content', minWidth: 'fit-content' }}
      startIcon={<HistoryOutlinedIcon />}
    >
      ประวัติการทดเวลา
    </Button>
  );
}
